import { useIndexedSnapScrollerContext } from '../../IndexedSnapScroller';

export const useMonthPickerScrollerContext = useIndexedSnapScrollerContext